module.exports = __webpack_public_path__ + "img/sest_farmingtoken.da6abaa.png";